import React, { useState } from "react";
import PrivacyPolicy from "./PrivacyPolicy";
import Welcome from "./Welcome";

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const handleWelcomeComplete = () => {
    setShowPrivacyPolicy(true);
  };

  return (
    <div>
      {showPrivacyPolicy ? (
        <PrivacyPolicy />
      ) : (
        <Welcome onComplete={handleWelcomeComplete} />
      )}
    </div>
  );
}

export default App;
